var e = /* @__PURE__ */ ((n) => (n.Simple = "simple", n.Normal = "normal", n.SelectionPage = "selection", n.None = "none", n))(e || {});
export {
  e as FooterStyle
};
//# sourceMappingURL=index3.js.map
